import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
import { Col, Card, Pagination, Row } from "react-bootstrap";
import BTable from "react-bootstrap/Table";

import { Common, Accessors, GlobalFilter, RolesEnum, SessionStorageKeys } from "../../../helper";
import { Action, CompletePupilDetails, pupilCloumns } from "./";
// import { Action, CompletePupilDetails, pupilCloumns, PupilDetailsModal } from "./";
import { styles, tableSizeP } from "../";
import { LoadingSpinner } from "../../Shared";
import { hasAny, isEmptyArray, isEmptyObject, SessionStorage } from "../../../util";
import * as commonApi from "../../../api/commonApi";

import "../../../assets/stlyes/SchoolAdminTableStyle.scss";

import retryIcon from "../../../assets/images/RetryWhite.svg"

const Table = (props) => {
  const { columns, data, setShowAcademicTabs } = props;
  const [allPupil, setAllPupil] = useState(false);
  const [school, setSchool] = useState()

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    globalFilter,
    setGlobalFilter,

    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const getAllPupil = () => {
    setAllPupil(true);
    SessionStorage.setItem(SessionStorageKeys.IsTeacherDataActive,false)
    SessionStorage.setItem(SessionStorageKeys.IsBackground,true)
    SessionStorage.setItem(SessionStorageKeys.SchoolDetailsUpdated,school?.Items?.schoolDetailsUpdated)
    setShowAcademicTabs(true);
  }
  const getSchoolDetails = async () => {
    const getSchool = await commonApi.getCurrentSchool();
    setSchool(getSchool);
  }

  useEffect(() => {
    getSchoolDetails();
  }, [])
  return (
    <>
      <Row className="mb-3">
        <Col className="d-flex justify-content-between">
          <GlobalFilter
            filter={globalFilter}
            setFilter={setGlobalFilter}
            searchBy={Common.SearchByNameOrUPN}
          />
          {school?.Items?.importDone ? <button className="pupilDetails-btn" onClick={getAllPupil}>{Common.UpdateAcademicDetails} <img src={retryIcon} alt=""/></button> : null}
        </Col>
      </Row>
      <BTable striped bordered hover responsive {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                <th key={i} {...column.getHeaderProps()}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr key={i} {...row.getRowProps()}>
                {row.cells.map((cell, i) => {
                  return (
                    <td key={i} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>

      <div className="d-flex justify-content-end" style={styles.paginate}>
        <span className="d-flex align-items-baseline">
          {Common.RowsPerPage}
          <select
            className="form-control w-auto mx-2"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[5, 10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </span>
        <span
          className="d-flex align-items-center"
          style={{ marginBottom: "13px" }}
        >
          {Common.Page}{" "}
          <strong>
            {" "}
            {pageIndex + 1} of {pageOptions.length}{" "}
          </strong>{" "}
        </span>

        <Pagination className="justify-content-end">
          <Pagination.First
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          />
          <Pagination.Prev
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          />
          <Pagination.Next
            onClick={() => nextPage()}
            disabled={!canNextPage}
          />
          <Pagination.Last
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          />
        </Pagination>
      </div>
      {/* {allPupil && <PupilDetailsModal setAllPupil={setAllPupil} />} */}
      {(allPupil && false) && <CompletePupilDetails setAllPupil={setAllPupil} />}
    </>
  );
};

const PupilTable = (props) => {
  const { setFullScreen, setShowAcademicTabs } = props
  const [puiplData, setPupils] = useState();
  const columns = React.useMemo(() => pupilCloumns, []);
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector((state) => state.login.user);

  const getData = async () => {
    setIsLoading(true);
    const adminPupil = await commonApi.adminPupil();
    if (!isEmptyArray(adminPupil?.Items)) {
      const updatedAdminPupilItems = adminPupil.Items.map((item) => {
        let ppDisplayed = false;

        item[Accessors.Action] = (<Action overAllData={item} pupilId={item.id} getData={getData} foreName={item.firstName} surName={item.lastName} />);

        item[Accessors.OtherNeeds] = (
          <div className="d-flex" style={{ gap: "10px" }}>
            {item[Accessors.OtherNeeds].childLookedAfter &&
              !ppDisplayed && (<span style={styles.characterisctics}>
              <div className="greenPointer_" style={{ backgroundColor: "#6D47FF", }}></div>{Common.PP}{(ppDisplayed = true)}</span>)}
            {item[Accessors.OtherNeeds].freeSchoolMealsE6 &&
              !ppDisplayed && (<span style={styles.characterisctics}>
              <div className="greenPointer_" style={{ backgroundColor: "#F4C900", }}></div>{Common.PP}{(ppDisplayed = true)}</span>)}
            {item[Accessors.OtherNeeds].freeSchoolMeals &&
              !ppDisplayed && (<span style={styles.characterisctics}>
              <div className="greenPointer_" style={{ backgroundColor: "#F4C900" }}></div>{Common.PP}{(ppDisplayed = true)}</span>)}
            {item[Accessors.OtherNeeds].eal && (
              <span style={styles.characterisctics}>
                <div
                  className="greenPointer_"
                  style={{
                    backgroundColor: "#F4C900",
                  }}
                ></div>{" "}
                {Common.Eal}
              </span>
            )}
            {item[Accessors.SenStatus] && (
              <span style={styles.characterisctics}>
                <div
                  className="greenPointer_"
                  style={{
                    backgroundColor: "#F50057",
                  }}
                ></div>
                {Common.SEND}
              </span>
            )}
            {item[Accessors.EHCP] && (
              <span style={styles.characterisctics}>
                <div
                  className="greenPointer_"
                  style={{
                    backgroundColor: "var(--below-colour)",
                  }}
                ></div>
                {Common.Ehcp}
              </span>
            )}
          </div>
        );

        item[Accessors.SenStatus] = (
          <div style={{ width: "100px" }}>
            {item[Accessors.SenStatus] && item[Accessors.EHCP] ? (
              <span>{Common.Ehcp}</span>
            ) : item[Accessors.SenStatus] ? (
              <span>{Common.Send_}</span>
            ) : (
              <span>{Common.NotSend}</span>
            )}
          </div>
        );

        item[Accessors.Ethnicity] = (
          <div style={{ width: "150px" }}>{item[Accessors.Ethnicity]}</div>
        );

        item[Accessors.Dob] = <div style={{ width: "100px" }}>{item[Accessors.Dob]}</div>;

        item[Accessors.Year] = (
          <div style={{ width: "100px" }}>{`${Common.Year} ${item[Accessors.Year]}`}</div>
        );

        item[Accessors.Eyfs] = (
          <div style={{ width: "80px" }}>
            {item[Accessors.Eyfs] ? <span>{Common.True}</span> : <span>{Common.False}</span>}
          </div>
        );

        item[Accessors.KsResults] = (
          <div className="d-flex flex-column" style={{ width: "110px" }}>
            <span>{`Writing-${item[Accessors.KsResults][Accessors.Ks1Results].Writing}`}</span>
            <span>{`Science-${item[Accessors.KsResults][Accessors.Ks1Results].Science}`}</span>
            <span>{`Maths-${item[Accessors.KsResults][Accessors.Ks1Results].Maths}`}</span>
            <span>{`Reading-${item[Accessors.KsResults][Accessors.Ks1Results].Reading}`}</span>
            <span>{`PE-${item[Accessors.KsResults][Accessors.Ks1Results].PE}`}</span>
          </div>
        );

        return item;
      });
      setPupils(updatedAdminPupilItems);
    } else {
      setPupils();
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    hasAny(user.userType, [RolesEnum.Admin]) ? pupilCloumns : pupilCloumns[0].Header === "" ? pupilCloumns.splice(0, 1) : pupilCloumns;
  }, []);


  return (
    <React.Fragment>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {!isEmptyObject(puiplData && puiplData) ? (
            <Row style={{ paddingRight: setFullScreen() }}>
              <Col sm={tableSizeP} style={styles.tableStyle}>
                <Card>
                  <Card.Body>
                    {puiplData && (
                      <Table
                        columns={columns}
                        data={puiplData && puiplData}
                        setShowAcademicTabs={setShowAcademicTabs}
                      />
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          ) : (
            <div className="d-flex justify-content-center">
              <h1>{Common.NoPupilFound}</h1>
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export { PupilTable };